const styles = theme => ({
  activeIcon: {
    color: theme.palette.primary.main
  }
})

export default styles
